import React, { useState } from "react";
import { Star } from "@/components/Monogram";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { useContent } from "@/content";

export default function Conditions() {
  const { lang, t } = useLang();
  const { content } = useContent();
  const c = content && content.conditions;
  if (!c) return null;
  const highlights = c.highlights[lang] || c.highlights.it;

  return (
    <section className="relative border-t hairline pt-14 pb-24 sm:pt-20 sm:pb-32" data-testid="conditions-section">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>{t(c.kicker)}</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display mt-6 text-3xl font-light leading-tight text-[#FAF9F6] sm:text-4xl" data-testid="conditions-title">
                {t(c.title)}
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-6 text-[17px] font-light leading-relaxed text-[#A1A1AA]">{t(c.text)}</p>
            </Reveal>
            <Reveal delay={0.18}>
              <Link
                to="/termini"
                className="mt-8 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#C5A059] underline-offset-4 transition-colors hover:underline"
                data-testid="conditions-cta"
              >
                {t(c.cta)}
              </Link>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-px bg-white/5 sm:grid-cols-2 lg:col-span-8">
            {highlights.map((h, i) => (
              <Reveal key={i} delay={i * 0.06} className="bg-[#0A0A0C]">
                <article className="h-full p-8 sm:p-10">
                  <div className="mb-5 flex items-center gap-3">
                    <Star size={10} fill="#C5A059" />
                    <span className="font-display text-sm italic text-[#C5A059]">0{i + 1}</span>
                  </div>
                  <h3 className="font-display text-[22px] font-light leading-snug text-[#FAF9F6] sm:text-[26px]" data-testid={`condition-title-${i}`}>
                    {h.title}
                  </h3>
                  <p className="mt-3 text-[15px] font-light leading-relaxed text-[#A1A1AA]">{h.body}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
